import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { FlexRowDiv, FlexColumnDiv } from "../common.styles";
import { HXButton } from "../HXButton";
export const SelectInput = styled.select `
    padding: 10px 14px;
    border: 1px solid ${colors.black_30};
    border-radius: 6px;
    font-size: ${fontSizes.STANDARD};
    min-width: 250px;
    background-color: white;

    &:focus {
        outline: none;
        border-color: ${colors.blue_main};
    }
`;
export const OriginBreakdownGrid = styled.div `
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;
`;
export const OriginCard = styled.div `
    padding: 16px;
    background-color: white;
    border: 1px solid ${colors.black_30};
    border-radius: 8px;
`;
export const OriginHeader = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: 600;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${colors.black_8};
`;
export const OriginStat = styled(FlexRowDiv) `
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid ${colors.black_4};

    &:last-child {
        border-bottom: none;
    }
`;
export const OriginStatLabel = styled.span `
    color: ${colors.black_lighter};
    font-size: ${fontSizes.SMALL};
`;
export const OriginStatValue = styled.span `
    font-weight: 600;
    font-size: ${fontSizes.STANDARD};
`;
export const DetailsSection = styled.div `
    margin-top: 32px;
`;
export const TableWrapper = styled.div `
    width: 100%;
    overflow-x: auto;
    margin-top: 16px;
`;
export const DataTable = styled.table `
    font-size: ${fontSizes.SMALL};
    width: 100%;
    min-width: 100%;
    border: 1px solid ${colors.black_30};
    border-collapse: collapse;
    background-color: white;

    & th {
        text-align: left;
        font-weight: 600;
        background-color: ${colors.black_4};
        white-space: nowrap;
    }

    & th,
    td {
        padding: 12px 14px;
        vertical-align: middle;
        border-bottom: 1px solid ${colors.black_8};
    }

    & tbody tr:hover {
        background-color: ${colors.black_4};
    }
`;
export const ExpandableRow = styled.tr `
    cursor: pointer;
    background-color: ${(props) => (props.expanded ? colors.black_4 : "transparent")};

    &:hover {
        background-color: ${colors.black_4};
    }
`;
export const ExpandedContent = styled.tr `
    background-color: ${colors.black_4};

    td {
        padding: 0;
    }
`;
export const ExpandedInner = styled.div `
    padding: 16px 24px;
`;
export const OriginBreakdownInline = styled(FlexRowDiv) `
    gap: 24px;
    flex-wrap: wrap;
`;
export const InlineOriginItem = styled(FlexColumnDiv) `
    gap: 4px;
    padding: 12px 16px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid ${colors.black_8};
    min-width: 180px;
`;
export const InlineOriginTitle = styled.div `
    font-size: 11px;
    color: ${colors.black_lighter};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;
export const InlineOriginStats = styled.div `
    font-size: 13px;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;
export const Pagination = styled(FlexRowDiv) `
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid ${colors.black_8};
`;
export const PageInfo = styled.span `
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_lighter};
    margin: 0 16px;
`;
export const PageButton = styled.button `
    padding: 8px 16px;
    border: 1px solid ${colors.black_30};
    border-radius: 4px;
    background-color: white;
    color: ${colors.black_main};
    font-size: ${fontSizes.SMALL};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};

    &:hover:not(:disabled) {
        border-color: ${colors.blue_main};
        background-color: ${colors.blue_5};
    }
`;
export const Badge = styled.span `
    display: inline-block;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    background-color: ${(props) => {
    switch (props.variant) {
        case "patient":
            return "#E3F2FD";
        case "organization":
            return "#F3E5F5";
        case "mcp":
            return "#E8F5E9";
        default:
            return colors.black_8;
    }
}};
    color: ${(props) => {
    switch (props.variant) {
        case "patient":
            return "#1565C0";
        case "organization":
            return "#7B1FA2";
        case "mcp":
            return "#2E7D32";
        default:
            return colors.black_main;
    }
}};
`;
export const RefreshButton = styled(HXButton) `
    margin-left: auto;
`;
